import WithRender from "../../templates/buttons/packing3dBackward.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["get3DPreviewId"])
  },
  methods: {
    onClick: function () {
      jQuery("#" + this.get3DPreviewId + " iframe")
        .get(0)
        .contentWindow.postMessage(
          JSON.stringify({
            animation_click: "backward"
          }),
          "*"
        );
    }
  }
});
